var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { format, startOfToday } from 'date-fns';
import { useCallback, useEffect, useMemo, useRef, useState, createContext } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
import { AptiveIcon, Tabs, Tab, Card, Loading } from '@aptive-env/storybook';
import { MapType } from 'interface';
import MiniCalendar from 'components/shared/MiniCalendar';
import { OfficeModal } from 'components/OfficeModal';
import Popover from 'components/shared/Popover';
import Map from 'components/Map';
import { Route, Stats as StatsIcon } from 'icons';
import Stats from 'components/Stats';
import Routes from 'components/Routes';
import styles from './index.module.scss';
import { fetchFleetRouteDetails, fetchFleetRoutes } from 'services/fleetRoute';
import { fetchUserAvatar } from 'services/calendar';
import { socket } from 'services/socket';
import { MapLayersToggleButtons } from 'components/MapLayersToggleButtons';
import { MapZoomControl } from 'components/MapZoomControl';
import { MapTypeChangeButton } from 'components/MapTypeChangeButton';
import { MapTypePopoverContent } from 'components/MapTypePopoverContent';
import { calculateTimeLeft } from 'utils/countdownTimer';
import RouteDetails from 'components/RouteDetails';
import ServiceReassignDrawer from 'components/ServiceReassignDrawer';
import { fetchRegions } from 'services/region';
import NoOffice from 'components/NoOffice';
import { useToast } from 'hooks/useToast';
import { getErrorMessage } from 'utils/error';
export var AppContext = createContext({
    isGoogleMapAPILoaded: false,
    googleMapAPILoadError: undefined,
});
var libraries = ['drawing', 'places', 'marker'];
var MapView = function () {
    var _a, _b, _c;
    var setToast = useToast().setToast;
    var today = startOfToday(); // TODO update day from api
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = useState(), fleetRoutesResult = _e[0], setFleetRoutesResult = _e[1];
    var _f = useState(false), fleetRoutesLoaded = _f[0], setFleetRoutesLoaded = _f[1];
    var _g = useState(today), currentDate = _g[0], setCurrentDate = _g[1];
    var _h = useState([]), regions = _h[0], setRegions = _h[1];
    var _j = useState(), selectedOffice = _j[0], setSelectedOffice = _j[1];
    var _k = useState(['homes', 'routes', 'route-polygon', 'service-pro', 'service-vehicles']), routeLayers = _k[0], setRouteLayers = _k[1];
    var _l = useState(false), isOfficeModalOpen = _l[0], setIsOfficeModalOpen = _l[1];
    var _m = useState(), mapCenter = _m[0], setMapCenter = _m[1];
    var _o = useState(false), isMapTypePopoverOpen = _o[0], setIsMapTypePopoverOpen = _o[1];
    var _p = useState(MapType.TRAFFIC), mapType = _p[0], setMapType = _p[1];
    var _q = useState(10), mapZoom = _q[0], setMapZoom = _q[1];
    var _r = useState(false), noOfficeModalOpen = _r[0], setNoOfficeModalOpen = _r[1];
    var _s = useState(calculateTimeLeft(currentDate, (_a = selectedOffice === null || selectedOffice === void 0 ? void 0 : selectedOffice.timezone) === null || _a === void 0 ? void 0 : _a.timezone)), timeLeft = _s[0], setTimeLeft = _s[1];
    var _t = useState(null), selectedRouteDetails = _t[0], setSelectedRouteDetails = _t[1];
    var _u = useState(''), selectedRouteName = _u[0], setSelectedRouteName = _u[1];
    var _v = useState(null), selectedReassignRouteId = _v[0], setSelectedReassignRouteId = _v[1];
    var _w = useState(null), selectedAppointmentId = _w[0], setSelectedAppointmentId = _w[1];
    var fetchFleetRoutesControllerRef = useRef();
    var _x = useJsApiLoader({
        googleMapsApiKey: (_b = process.env.REACT_APP_GOOGLE_MAPS_API_KEY) !== null && _b !== void 0 ? _b : '',
        mapIds: [(_c = process.env.REACT_APP_GOOGLE_MAPS_ID) !== null && _c !== void 0 ? _c : ''],
        libraries: libraries,
    }), isLoaded = _x.isLoaded, loadError = _x.loadError;
    var isRoutesStarted = useMemo(function () {
        return timeLeft === '';
    }, [timeLeft]);
    var fetchRouteDetails = function (route, index) { return __awaiter(void 0, void 0, void 0, function () {
        var response, details, avatarResponse, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    return [4 /*yield*/, fetchFleetRouteDetails(route.id)];
                case 1:
                    response = _a.sent();
                    if (!(response._metadata.success && response.result.route)) return [3 /*break*/, 4];
                    details = __assign({}, response.result.route);
                    if (!details.external_id) return [3 /*break*/, 3];
                    return [4 /*yield*/, fetchUserAvatar(details.external_id)];
                case 2:
                    avatarResponse = _a.sent();
                    if (avatarResponse._metadata.success && avatarResponse.result.avatarBase64) {
                        details.avatar = avatarResponse.result.avatarBase64;
                    }
                    _a.label = 3;
                case 3:
                    setSelectedRouteDetails(details);
                    setSelectedRouteName("Route ".concat(index + 1, " - ").concat(format(currentDate, 'ddMMMuuuu')));
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    e_1 = _a.sent();
                    setToast({
                        status: 'danger',
                        message: getErrorMessage(e_1, 'Unable to load route details.'),
                    });
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleCloseRouteDetails = function () {
        setSelectedRouteDetails(null);
        setSelectedRouteName('');
        setSelectedReassignRouteId(null);
    };
    useEffect(function () {
        var timer = setInterval(function () {
            var _a;
            setTimeLeft(calculateTimeLeft(currentDate, (_a = selectedOffice === null || selectedOffice === void 0 ? void 0 : selectedOffice.timezone) === null || _a === void 0 ? void 0 : _a.timezone));
        }, 1000);
        return function () { return clearInterval(timer); };
    }, [currentDate, selectedOffice]);
    var fetchAllServiceProAvatars = function (result, signal) { return __awaiter(void 0, void 0, void 0, function () {
        var tempResult, promises;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    tempResult = __assign({}, result);
                    promises = [];
                    tempResult.routes.forEach(function (route) {
                        if (route.external_id) {
                            promises.push(fetchUserAvatar(route.external_id, { signal: signal }));
                        }
                    });
                    return [4 /*yield*/, Promise.allSettled(promises)
                            .then(function (avatars) {
                            avatars.forEach(function (avatar, index) {
                                tempResult.routes[index].avatar = avatar.status === 'fulfilled' ? avatar.value.result.avatarBase64 : undefined;
                            });
                        })];
                case 1:
                    _a.sent();
                    setFleetRoutesResult(tempResult);
                    setFleetRoutesLoaded(true);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (!selectedOffice) {
            return;
        }
        setIsLoading(true);
        setFleetRoutesLoaded(false);
        if (fetchFleetRoutesControllerRef.current) {
            fetchFleetRoutesControllerRef.current.abort();
        }
        fetchFleetRoutesControllerRef.current = new AbortController();
        fetchFleetRoutes(selectedOffice.id, currentDate, fetchFleetRoutesControllerRef.current.signal)
            .then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                if (response._metadata.success && response.result) {
                    setFleetRoutesResult(response.result);
                    fetchAllServiceProAvatars(response.result, (_a = fetchFleetRoutesControllerRef.current) === null || _a === void 0 ? void 0 : _a.signal);
                    setIsLoading(false);
                }
                return [2 /*return*/];
            });
        }); })
            .catch(function (e) {
            if (e.code !== 'ERR_CANCELED') {
                setToast({
                    status: 'danger',
                    message: getErrorMessage(e),
                });
                console.error('Error when fetching fleet routes', e);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentDate, selectedOffice]);
    useEffect(function () {
        if (!fleetRoutesLoaded || !selectedOffice) {
            return;
        }
        socket.on('connect', function () {
            console.log('Connected');
            // Request to join a room
            socket.emit('join', 'aro-service');
            console.log('Joined to room: aro-service');
        });
        socket.on('disconnect', function () {
            console.log('Disconnected');
        });
        socket.on('connect_error', function () {
            console.log('Connection Error');
            console.log('Attempting reconnect...');
            setTimeout(function () {
                socket.connect();
            }, 1000);
        });
        socket.on("track-office-".concat(selectedOffice.id), function () {
            var _a, _b;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var data = args[0];
            console.log('Event Received:', 'aro-service', "tracking-office-".concat(selectedOffice.id), data);
            // Update the map with the new data
            var updatedFleetRoutesResult = __assign({}, fleetRoutesResult);
            (_a = updatedFleetRoutesResult.routes) === null || _a === void 0 ? void 0 : _a.forEach(function (route) {
                data['routes'].forEach(function (newRoute) {
                    if (route.id === newRoute.id) {
                        route.actual_stats = newRoute.actual_stats;
                        route.tracking_data = newRoute.tracking_data;
                        route.statistics = newRoute.statistics;
                    }
                });
            });
            updatedFleetRoutesResult.summary = data['summary'];
            setFleetRoutesResult(updatedFleetRoutesResult);
            // Update the selected fleet route details with the live data
            if (selectedRouteDetails) {
                var liveData = (_b = updatedFleetRoutesResult.routes) === null || _b === void 0 ? void 0 : _b.find(function (route) { return route.id === selectedRouteDetails.id; });
                if (liveData) {
                    var updatedSelectedRouteDetails = __assign(__assign({}, selectedRouteDetails), { statistics: liveData.statistics, actual_stats: liveData.actual_stats });
                    if (liveData.events) {
                        updatedSelectedRouteDetails.events = liveData.events;
                    }
                    setSelectedRouteDetails(updatedSelectedRouteDetails);
                }
            }
        });
        return function () {
            socket.off('connect_error');
            socket.off('connect');
            socket.off('disconnect');
            socket.off("track-office-".concat(selectedOffice.id));
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fleetRoutesLoaded]);
    useEffect(function () {
        fetchRegions()
            .then(function (regions) {
            setRegions(regions);
            if (regions.length > 0) {
                setSelectedOffice(regions[0].offices[0]);
                setMapCenter(regions[0].offices[0].location);
            }
            else {
                setNoOfficeModalOpen(true);
            }
        })
            .catch(function (error) {
            setToast({
                status: 'danger',
                message: getErrorMessage(error)
            });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleDateChange = useCallback(function (date) { return setCurrentDate(date); }, []);
    var toggleRouteLayer = function (layer) {
        if (routeLayers.includes(layer)) {
            setRouteLayers(routeLayers.filter(function (item) { return item !== layer; }));
        }
        else {
            setRouteLayers(__spreadArray(__spreadArray([], routeLayers, true), [layer], false));
        }
    };
    var handleChangeOffice = function (office) {
        setSelectedOffice(office);
        setIsOfficeModalOpen(false);
        setMapCenter(office.location);
    };
    var handleChangeMapType = function (type) {
        setMapType(type);
        setIsMapTypePopoverOpen(false);
    };
    var handleZoom = function (type) {
        if (type === 'in') {
            setMapZoom(mapZoom + 1);
        }
        if (type === 'out' && mapZoom > 0) {
            setMapZoom(mapZoom - 1);
        }
    };
    var completedAppointments = useMemo(function () {
        if (!selectedRouteDetails) {
            return 0;
        }
        var count = 0;
        for (var _i = 0, _a = Object.entries(selectedRouteDetails.events); _i < _a.length; _i++) {
            var _b = _a[_i], value = _b[1];
            if (value.status === 'Completed' && value.type === 'Appointment')
                count++;
        }
        return count;
    }, [selectedRouteDetails]);
    var _y = useState(0), currentTab = _y[0], setCurrentTab = _y[1];
    return (_jsx(AppContext.Provider, __assign({ value: { isGoogleMapAPILoaded: isLoaded, googleMapAPILoadError: loadError } }, { children: _jsxs("div", __assign({ className: "grow flex relative px-[32px] py-[24px]" }, { children: [_jsx("div", __assign({ className: "h-[calc(100%-48px)] absolute z-50" }, { children: selectedRouteDetails ? (_jsx(RouteDetails, { name: selectedRouteName, route: selectedRouteDetails, selectedOfficeId: selectedOffice === null || selectedOffice === void 0 ? void 0 : selectedOffice.id, selectedDate: currentDate, isStarted: isRoutesStarted, onClose: handleCloseRouteDetails, setSelectedReassignRouteId: setSelectedReassignRouteId })) : (_jsxs(Card, __assign({ className: "h-[calc(100%-34px)] min-w-[375px] bg-white mx-[15px] my-[17px] rounded-lg shadow-[0px_3px_8px_0px_rgba(87,102,117,0.06),_0px_6px_12px_0px_rgba(106,115,129,0.16)] flex flex-col overflow-hidden" }, { children: [_jsx(MiniCalendar, { className: "bg-white border-b border-gray-100 rounded-t-lg", currentDate: currentDate, view: "week", onChange: handleDateChange }), _jsxs("div", __assign({ className: "pl-[24px] pr-[8px] py-[16px] bg-gray-50 border-b border-gray-100 text-gray-600 flex items-center justify-between" }, { children: [_jsxs("div", __assign({ className: "flex flex-col gap-2" }, { children: [_jsxs("div", __assign({ className: "text-sm\tfont-normal leading-4" }, { children: ["Office: ", _jsx("span", { children: selectedOffice ? "".concat(selectedOffice === null || selectedOffice === void 0 ? void 0 : selectedOffice.region, " /") : 'N/A' })] })), selectedOffice && _jsx("div", __assign({ className: "text-base leading-4 font-bold" }, { children: selectedOffice.name }))] })), _jsxs("div", __assign({ className: "flex items-center justify-center w-[64px] h-[40px] cursor-pointer", onClick: function () { return setIsOfficeModalOpen(true); } }, { children: [_jsx(AptiveIcon, { className: "w-[24px] h-[24px] stroke-gray-600 fill-none", icon: "globeAlt" }), _jsxs("div", __assign({ className: "w-[24px] h-[24px] flex flex-col items-center" }, { children: [_jsx(AptiveIcon, { className: "w-[16px] h-[14px] stroke-gray-600 fill-none", icon: "chevronUp" }), _jsx(AptiveIcon, { className: "w-[16px] h-[14px] stroke-gray-600 fill-none", icon: "chevronDown" })] }))] }))] })), !isRoutesStarted && (_jsxs("div", __assign({ className: "flex justify-between items-center px-6 py-4 bg-gray-200" }, { children: [_jsx("span", __assign({ className: "text-[14px] font-normal text-text-default" }, { children: "Routes start in:" })), _jsx("span", __assign({ className: "text-xs font-semibold leading-4 text-gray-600" }, { children: timeLeft }))] }))), selectedOffice && (_jsx(OfficeModal, { open: isOfficeModalOpen, className: "w-[658px] min-h-[599px]", selectedOffice: selectedOffice, regions: regions, onSelectOffice: function (office) { return handleChangeOffice(office); }, onClose: function () { return setIsOfficeModalOpen(false); }, center: selectedOffice.location, appContext: AppContext })), isLoading ? (_jsx("div", __assign({ className: "flex justify-center items-center min-h-[200px]" }, { children: _jsx(Loading, {}) }))) : (_jsxs("div", __assign({ className: "flex flex-col grow h-0" }, { children: [_jsx("div", __assign({ className: "px-4" }, { children: _jsxs(Tabs, __assign({ className: "p-1 pb-[3px] border-b border-[#E0E3E8]", value: currentTab, onChange: setCurrentTab }, { children: [_jsxs(Tab, __assign({ className: "h-[40px] flex flex-1 justify-center items-center gap-2 ".concat(currentTab === 0 ? styles.activeTab : ''), value: 0 }, { children: [_jsx(Route, { className: "".concat(currentTab === 0 ? styles.activeSvg : '') }), _jsx("span", __assign({ className: "font-inter font-bold text-xs" }, { children: "Routes" }))] })), _jsxs(Tab, __assign({ className: "h-[40px] flex flex-1 justify-center items-center gap-2 ".concat(currentTab === 1 ? styles.activeTab : ''), value: 1 }, { children: [_jsx(StatsIcon, { className: "".concat(currentTab === 1 ? styles.activeSvg : '') }), _jsx("span", __assign({ className: "font-inter font-bold text-xs" }, { children: "Stats" }))] }))] })) })), fleetRoutesResult && fleetRoutesResult.routes && fleetRoutesResult.summary && (currentTab === 0
                                        ? _jsx(Routes, { items: fleetRoutesResult.routes, isStarted: isRoutesStarted, onSelect: fetchRouteDetails })
                                        : _jsx(Stats, { items: fleetRoutesResult.summary }))] })))] }))) })), selectedReassignRouteId && (_jsx(ServiceReassignDrawer, { routeId: selectedRouteDetails === null || selectedRouteDetails === void 0 ? void 0 : selectedRouteDetails.id, officeId: selectedOffice === null || selectedOffice === void 0 ? void 0 : selectedOffice.id, date: currentDate, handleClose: function () {
                        setSelectedReassignRouteId(null);
                    }, completedAppointments: completedAppointments, setSelectedAppointmentId: setSelectedAppointmentId })), _jsx("div", __assign({ className: "absolute z-10 left-[450px] top-[41px]" }, { children: _jsx(MapLayersToggleButtons, { routeLayers: routeLayers, onToggleRouteLayer: toggleRouteLayer }) })), _jsx("div", __assign({ className: "absolute z-10 ".concat(selectedReassignRouteId ? 'right-[480px]' : 'right-[48px]', " top-[41px]") }, { children: _jsx(Popover, __assign({ open: isMapTypePopoverOpen, position: "left", className: "!bg-transparent !shadow-none", content: _jsx(MapTypePopoverContent, { type: mapType, onChangeType: handleChangeMapType }), onClickOutside: function () { return setIsMapTypePopoverOpen(false); } }, { children: _jsx(MapTypeChangeButton, { open: isMapTypePopoverOpen, onClick: function () { return setIsMapTypePopoverOpen(function (value) { return !value; }); } }) })) })), _jsx("div", __assign({ className: "absolute z-10 ".concat(selectedReassignRouteId ? 'right-[480px]' : 'right-[48px]', " top-[90px]") }, { children: _jsx(MapZoomControl, { onZoom: handleZoom }) })), _jsx(Map, { mapType: mapType, mapData: fleetRoutesResult, routeLayers: routeLayers, center: mapCenter, zoom: mapZoom, selectedReassignRouteId: selectedReassignRouteId, selectedAppointmentId: selectedAppointmentId, selectedRouteId: selectedRouteDetails === null || selectedRouteDetails === void 0 ? void 0 : selectedRouteDetails.id }), noOfficeModalOpen && (_jsx(NoOffice, { isOpen: noOfficeModalOpen, onClose: function () { return setNoOfficeModalOpen(false); } }))] })) })));
};
export default MapView;
